module.exports = __webpack_public_path__ + "img/img_success.edd1ac91.png";